import { RectangleStackIcon } from "@heroicons/react/20/solid";
import React from "react";
import { connect } from "react-redux";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import PayWithFyorin from "./fyorin/PayWithFyorin";
import { ActionListOption } from "@/common/custom-selectors/ActionList";

const IntegrationPayments = ({ integrations, openBankTransfer, userPermissions, period, action, jurisdiction }) => {
	if (!period || userPermissions == "None") return null;
	const bankTransferType = jurisdiction === "UK" ? "BACS" : "SEPA";

	if (integrations?.includes("Fyorin")) return <PayWithFyorin { ... { action, period }} />;

	if (action)
		return (
			<ActionListOption
				option={{
					label: `Pay by ${bankTransferType} File`,
					icon: RectangleStackIcon,
					onClick: () => openBankTransfer(period),
				}}
			/>
		);
	return null;
};

const mapStateToProps = (state) => {
	const paymentList =
		state.integration?.payment &&
		Object.values(state.integration?.payment)?.reduce((prev, curr) => {
			prev.push(curr.name);
			return prev;
		}, []);
	return {
		company: state?.company?.settings?.org,
		jurisdiction: state?.company?.settings?.jurisdiction,
		integrations: paymentList,
		userPermissions: state?.permissions?.my?.permissions?.timesheets,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openBankTransfer: (period) => {
		dispatch(COMPANYACTIONS.setBankTransferModal(true));
		dispatch(COMPANYACTIONS.setBankTransferPeriod(period));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationPayments);
